import { useQuery } from "react-query";
import { Task } from "../../tasks/models/Task";
import { supabase } from "../../../supabaseClient";

export function useSnippet({ id }: { id: string | undefined }) {
  const fetchSnippet = async (taskId: number) => {
    const { data, error } = await supabase
      .from("tasks")
      .select("*, task_votes(*)")
      .eq("id", taskId)
      .single();

    if (error) {
      throw new Error("Failed to fetch snippet");
    }

    return data as Task;
  };
  const {
    data: loadedSnippet,
    isLoading: taskLoading,
    isError,
  } = useQuery<Task>(["snippet", id], () => fetchSnippet(parseInt(id!)), {
    enabled: !!id,
  });

  return { loadedSnippet, taskLoading, isError };
}
